// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4166":"771e6629","4245":"2d790ace","8194":"2d790ace","9107":"2d790ace"}[chunkId] + ".chunk.css";
};